import { getApolloClient } from '$apollo/util';
import type { CmsProductItem } from '$cms/types';
import { removeNullValues } from '$util/basic';
import type { AnyObject } from '$util/types';
import type {
  QueryFetchProductCollectionData,
  QueryFetchProductCollectionDataVariables,
} from './gql/queries/queryFetchProductCollectionData';
import { QUERY_FETCH_PRODUCT_COLLECTION_DATA } from './gql/queries/queryFetchProductCollectionData';

type FetchProductCollectionDataContext = AnyObject & {
  readonly headers?: AnyObject;
};

const LEAST_PRIORITY_NUMBER = Number.POSITIVE_INFINITY;

export const getPopularitySortedData = (parsedData: CmsProductItem[]): CmsProductItem[] => {
  const sortedData = [...parsedData].sort(
    (first: CmsProductItem, second: CmsProductItem) =>
      (first.popularity || LEAST_PRIORITY_NUMBER) - (second.popularity || LEAST_PRIORITY_NUMBER)
  );
  return sortedData;
};

export async function fetchProductCollectionData(
  { filter, segment, preview, limit = 20 }: QueryFetchProductCollectionDataVariables,
  context?: FetchProductCollectionDataContext
): Promise<CmsProductItem[]> {
  const apollo = getApolloClient();
  const { data } = await apollo.query<
    QueryFetchProductCollectionData,
    QueryFetchProductCollectionDataVariables
  >({
    query: QUERY_FETCH_PRODUCT_COLLECTION_DATA,
    variables: {
      filter,
      segment,
      preview,
      limit,
    },
    context: {
      needsAuthentication: false,
      ...context,
    },
    fetchPolicy: 'no-cache',
  });

  const parsedData = removeNullValues(data?.getCmsProducts || []);
  const sortedData = getPopularitySortedData(parsedData);
  return sortedData;
}
